<template>
    <div>
        <div class="rtitle flex justify-between align-center bg-white rone">
            <div class="colorleft">企业服务</div>
            <div class="colorright">
                <div @click="tolist" class="t_btn pointer">需求记录</div>
            </div>
        </div>
        <div class="cball">
            <div class="bg-white" style="min-height: 570px;padding: 20px;">
                <el-row>
                    <el-col :span="24">
                        <div class="t_brief">
                            <div style="margin-bottom: 10px;">① 维修需求请附加照片内容</div>
                            <div>② 借用会议室，请提出借用名称、借用时间、借用时长</div>
                        </div>
                    </el-col>
                </el-row>
                <div style="margin-top: 25px;">
                    <div style="width: 650px;margin: 0 auto;">
                        <el-form :model="cominfo" :rules="rules" ref="ruleForm" style="text-align:left;" :label-width="formLabelWidth">
                            <el-form-item label="标题：" prop="title">
                                <el-input style="width: 420px;" placeholder="请输入" v-model="cominfo.title" autocomplete="off"></el-input>
                            </el-form-item>
                            
                            <el-form-item label="申请简述：" prop="content" >
                                <el-input type="textarea" :rows="2" style="width: 420px;" placeholder="请输入咨询内容" v-model="cominfo.content" autocomplete="off"></el-input>
                            </el-form-item>

                            <el-form-item label="图片：" prop="file">
                                <!-- <el-upload
                                    class="avatar-uploader"
                                    :action="action"
                                    :show-file-list="false"
                                    :on-success="Successone"
                                    list-type="picture-card"
                                    :file-list="cominfo.file"
                                    >
                                    <img v-if="cominfo.file" :src="cominfo.file | addurl" class="avatar">
                                    <i class="el-icon-plus avatar-uploader-icon"></i>
                                </el-upload>
                                <el-dialog :visible.sync="dialogVisible">
                                    <img width="100%" :src="dialogImageUrl" alt="">
                                </el-dialog> -->
                                <!-- :on-preview="handlePictureCardPreview" -->
                                <el-upload
                                :action="action"
                                list-type="picture-card"
                                :on-remove="handleRemove"
                                :on-success="Successone"
                                :file-list="cominfo.file"
                                >
                                <i class="el-icon-plus"></i>
                                </el-upload>
                                <el-dialog :visible.sync="dialogVisible">
                                <img width="100%" :src="dialogImageUrl" alt="">
                                </el-dialog>
                            </el-form-item>
                            <el-form-item>
                                <el-button type="primary" :disabled="substatus" @click="submitForm('ruleForm')">提交申请</el-button>
                            </el-form-item>
                        </el-form>
                    </div>
                    
                </div>
            </div>
        </div>
        
    </div>
</template>
<script>
export default({
    data() {
        return{
            dialogVisible: false,
            dialogImageUrl: '',
            usreinfo: '',
            cominfo:{
                content: '',
                title: '',
                file: [],
                shop_id: '',
            },
            formLabelWidth: '120px',
            action: 'https://yt.daoben.net/api/common/upload',
            rules: {
                title: [
                    { required: true, message: '请输入标题', trigger: 'blur' },
                ],
                content: [
                    { required: true, message: '请输入简述', trigger: 'blur' },
                ]
            },
            substatus: false
        }
    },
    methods:{
        handleRemove(file, fileList) {
            console.log(file,fileList)
            this.cominfo.file = fileList;

        },
        Successone(res){
            console.log(res)
            var news = {
                name: 'adfs',
                url: res.data.fullurl,
                url_true: res.data.url
            }
            this.cominfo.file.push(news)
        },
        tolist(){
            this.$router.push({name: 'service'})
        },
        submitForm(){
            this.$refs['ruleForm'].validate((valid) => {
            if (valid) {
                // alert('submit!');
                this.substatus = true
                this.tosub();
            } else {
                console.log('error submit!!');
                return false;
            }
            });
        },
        tosub(){
            console.log(this.cominfo)
                var newarr = [];
            if(this.cominfo.file.length){
                this.cominfo.file.forEach(element => {
                    newarr.push(element.url_true)
                });
            }
            var data = {
                shop_id: this.usreinfo.shop.id,
                title: this.cominfo.title,
                content: this.cominfo.content,
                file: newarr.join(',')
            }
            this.$api.index.feedback(data).then(res=>{
                this.$message({
                    message: '提交成功',
                    type: 'success',
                    duration: 1000
                });
                setTimeout(() => {
                    this.$router.push({name: 'service'})
                }, 800);
            }).catch(res=>{
                this.substatus = false;
            })
        },
    },
    created(){
        this.usreinfo = JSON.parse(localStorage.getItem('userinfo'));
        
    }
})
</script>

<style scoped>
    .rtitle{
        padding: 20px;
        font-size: 16px;
        color: #7d7d7d;
        border-bottom: 8px solid #f4f4f4;
    }
    .rone{
        border-radius: 12px;
    }
    .colorleft{
        color: #191919;font-size: 20px;
    }
    .colorright{
        color: #7e7e7e;font-size: 18px;
    }
    .t_btn{
        width: 138px;
        height: 46px;
        background-color: #1759d8;
        border-radius: 4px;
        text-align: center;
        line-height: 46px;
        color: #ffffff;
        font-size: 18px;
    }

    .t_brief{
        background-color: #fdf3f3;
	    border-radius: 4px;
        padding: 22px;
        color: #ff785d;
        font-size: 16px;
    }
</style>


// WEBPACK FOOTER //
// apply.vue?bd3cde8c